import type Map from 'ol/Map';

/** Minimum OpenLayers zoom for farm-level field tools (draw / map-view AI delineation). */
export const FARM_LEVEL_MIN_ZOOM = 15;

export function getOlMapZoom(map: Map | null | undefined): number | null {
  if (!map) return null;
  const zoom = map.getView().getZoom();
  return zoom ?? null;
}

export function isMapZoomedForFarmLevel(zoom: number | null | undefined): boolean {
  return typeof zoom === 'number' && zoom >= FARM_LEVEL_MIN_ZOOM;
}

export function farmLevelZoomTooLowMessage(zoom: number | null | undefined): string {
  const current = typeof zoom === 'number' ? Math.round(zoom) : null;
  const currentPart = current != null ? ` (current zoom: ${current})` : '';
  return `Zoom in closer to farm level before using this tool — zoom level ${FARM_LEVEL_MIN_ZOOM} or higher is required${currentPart}.`;
}

export function assertFarmLevelMapZoom(
  zoom: number | null | undefined
): { ok: true } | { ok: false; message: string } {
  if (isMapZoomedForFarmLevel(zoom)) return { ok: true };
  return { ok: false, message: farmLevelZoomTooLowMessage(zoom) };
}
